export const JSON_SPACE: number = 2
